import type { MouseEvent } from 'react';
import type { ZzzfunConfig } from '@/hooks/useZzzfunConfig';
import { zzzfunNavItems, scrollToZzzfunSection } from './zzzfun-navigation';

interface ZzzfunFooterProps {
  config: ZzzfunConfig;
}

export default function ZzzfunFooter({ config }: ZzzfunFooterProps) {
  const handleNavClick = (event: MouseEvent<HTMLAnchorElement>, id: string) => {
    event.preventDefault();
    scrollToZzzfunSection(id);
  };

  return (
    <footer className="w-full bg-primary-50 dark:bg-background-100">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-10 lg:flex-row lg:justify-between">
          {/* 品牌 */}
          <div className="max-w-sm">
            <div className="flex items-center gap-2">
              <span className="flex h-10 w-10 items-center justify-center overflow-hidden rounded-xl border border-background-200/70 bg-background-50">
                <img
                  src="/images/zzzfun-logo.png"
                  alt="ZzzFun官方图标"
                  title="ZzzFun动漫官网下载 - ZzzFun.net"
                  className="h-7 w-7 object-contain"
                />
              </span>
              <span className="font-label text-xl font-bold text-foreground-950">
                ZzzFun<span className="text-primary-600">.net</span>
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              ZzzFun是以兴趣为核心的番剧播放工具，聚合排行榜、新番时间表与分区发现，支持 Android、iOS、HarmonyOS、Windows 全平台同步，畅享高清流畅追番体验。
            </p>
          </div>

          {/* 导航 */}
          <div className="flex flex-col gap-3">
            <h4 className="text-sm font-bold text-foreground-950">网站导航</h4>
            <nav className="flex flex-col gap-2">
              {zzzfunNavItems.map((item) => (
                <a
                  key={item.id}
                  href={`#${item.id}`}
                  onClick={(event) => handleNavClick(event, item.id)}
                  className="w-fit whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>

          {/* 联系方式 */}
          <div className="flex flex-col gap-3">
            <h4 className="text-sm font-bold text-foreground-950">联系我们</h4>
            <div className="flex flex-col gap-2 text-sm text-foreground-600">
              <span className="flex items-center gap-2">
                <i className="ri-mail-line text-base text-primary-600" />
                商务合作邮箱
              </span>
              <span className="font-medium text-foreground-900">{config.contactEmail}</span>
              <span className="flex items-center gap-2">
                <i className="ri-global-line text-base text-primary-600" />
                官方网站
              </span>
              <span className="font-medium text-foreground-900">ZzzFun.net</span>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200/70 pt-6 text-xs text-foreground-600 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} ZzzFun 保留所有权利。</p>
          <p>ZzzFun动漫官网下载</p>
        </div>
      </div>
    </footer>
  );
}